<template>
    <el-skeleton :rows="15" animated :count="3" />
</template>
